import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/speedprint_logo.png'


const _hoisted_1 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_2 = { class: "row header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 logo no-padding-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "speedprint2.5 - Kopland"
  })
], -1)
const _hoisted_4 = { class: "col-md-6 no-padding" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "las la-sms"
}
const _hoisted_7 = { class: "col-md-2 text-end" }
const _hoisted_8 = { class: "clock" }
const _hoisted_9 = { class: "col-md-2 text-end no-padding-right" }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = {
  class: "btn btn-sm btn-primary dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "las la-user-tie" }, null, -1)
const _hoisted_13 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "las la-user-edit" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "las la-sign-out-alt" }, null, -1)
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-12 d-flex no-padding" }
const _hoisted_21 = { class: "menu" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-list-alt big-glyph" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Zlecenia", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-plus-circle big-glyph" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Nowe", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-comments-dollar big-glyph" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Wycena", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-users big-glyph" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Klienci", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-print big-glyph" })
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Media", -1)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-chart-bar big-glyph" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Statystyki", -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-eye big-glyph" })
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Log", -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-sms big-glyph" })
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Wiadomości", -1)
const _hoisted_45 = {
  key: 0,
  class: "unread-info"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-archive big-glyph" })
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Archiwum", -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-user-cog big-glyph" })
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "link-text" }, "Użytkownicy", -1)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "flex-grow-1 main-container-padding" }
const _hoisted_53 = {
  key: 1,
  class: "cont-for-vert-centered-div d-flex align-items-center justify-content-center"
}

import { ref, computed } from 'vue';
  import { useStore } from '@/store';
  import { useRouter } from 'vue-router';
  
  // import local stuff
  import { goTo } from './router';
  import { ActionTypes } from './store/speedprint/action-types';
  import { ActiveUser } from './store/speedprint/models/activeUser';

  // Provided in main.ts
  import { inject } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  // import vue stuff
  const emitter:any = inject('emitter');
  const moment:any = inject('moment');
  const pieSocket:any = inject('pieSocket');
  
  emitter.on('login', (evt:any) => { 
    getUsers();
    startIntervals(); 
    isAuth.value = true;
    subscribeToPieSocket();
  });
  emitter.on('logout', (evt:any) => { 
    clearIntervals(); 
    logout();
  });

  // local variables
  const router = useRouter();
  const store = useStore();
  const isAuth = ref(false);
  const timeString = ref('');
  const dateString = ref('');
  const unreadMessages = ref(0);
  const intervalId_showDate = ref(0);
  const intervalId_showTime = ref(0);
  const intervalId_heartbeat = ref(0);
  const isAuthGetter = store.getters.isAuth;
  isAuth.value = isAuthGetter();
  const activeUsers = computed(() => store.state.speedprint.activeUsers);
  const currentUser = computed(() => store.state.speedprint.user);

  const loginInfo = () => {
    return store.state.speedprint.user.name;
  }
  const roleInfo = () => {
    return store.state.speedprint.user.levelName;
  }
  const canISeeThis = (menuItem: string) => {
    return true;
  }
  const logout = () => {
    pieSocket.unsubscribe('speedprint');
    isAuth.value = false;
    clearIntervals();
    store.dispatch(ActionTypes.LOGOUT);
  }

  const checkUserStatus = (last_activity:string) => {
    const diff = moment().diff(moment.unix(parseInt(last_activity)), 'seconds');
		return diff > 300 ? diff > 1800 ? "grey" : "orange" : "green";
	};

  const canSendMessage = (userGuid:string) => {
    return currentUser.value.id != userGuid;
  }

  const writeMessage = (u:ActiveUser) => {
    return true;
  }

  const showTime = () => {
		timeString.value = moment().format("HH:mm:ss");
	}

  const showDate = () => {
    dateString.value = moment().format("ddd, DD/MM/YYYY") + ", tydzień: " + moment().format("WW");
  }

  const heartbeat = async() => {
    await store.dispatch(ActionTypes.HEARTBEAT);
  }

  // lookup functions
  const getUsers = async() => {
    await store.dispatch(ActionTypes.GET_USERS);
  }
  const getLogEvents = async() => {
    await store.dispatch(ActionTypes.GET_LOG_EVENTS);
  }
  // --- END OF: lookup functions

  const clearIntervals = () => {
    clearInterval(intervalId_heartbeat.value);
    clearInterval(intervalId_showTime.value);
    clearInterval(intervalId_showDate.value);
  }

  const startIntervals = () => {
    showTime();
    showDate();
    heartbeat();
    intervalId_showDate.value = setInterval(() => {showDate()}, 900000);
    intervalId_showTime.value = setInterval(() => {showTime()}, 1000);
    intervalId_heartbeat.value = setInterval(() => {heartbeat()}, 10000);
  }

  const subscribeToPieSocket = () => {
    pieSocket.subscribe('speedprint').then((channel:any) => { 
      channel.listen('user-state-change', (data:any, meta:any) => {
        store.dispatch(ActionTypes.UPDATE_STATES, {activeUsers: data});
      });
    });
  }

  // init
  if(sessionStorage.getItem('token')){
    getLogEvents();
    getUsers();
    startIntervals();
    subscribeToPieSocket();
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isAuth.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeUsers.value, (u) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["float-start me-4", canSendMessage(u.id) ? 'pointer' : '']),
                  key: u.id,
                  onClick: ($event: any) => (canSendMessage(u.id) ? writeMessage(u) : '')
                }, [
                  (canSendMessage(u.id))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  _createElementVNode("strong", null, _toDisplayString(u.initials), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(checkUserStatus(u.lastActivity))
                  }, "●", 2),
                  _createTextVNode(" " + _toDisplayString(u.lastSeenState), 1)
                ], 10, _hoisted_5))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(timeString.value), 1),
              _createElementVNode("div", null, _toDisplayString(dateString.value), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(loginInfo()), 1)
                ]),
                _createElementVNode("ul", _hoisted_13, [
                  (canISeeThis('edycja_profilu') || canISeeThis('zmiana_hasla'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goTo)('profil')))
                        }, [
                          _hoisted_15,
                          _createTextVNode(" Edytuj swój profil ")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_16,
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
                    }, [
                      _hoisted_17,
                      _createTextVNode(" Wyloguj")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(roleInfo()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (canISeeThis('menu_listaZlecen'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "menu-link text-center",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goTo)('dashboard','zlecenia')))
                    }, _hoisted_24))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_noweZlecenie'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "menu-link text-center",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(goTo)('newOrder','nowe')))
                    }, _hoisted_27))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_wycena'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "menu-link text-center",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(goTo)('pricing','wycena')))
                    }, _hoisted_30))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_klienci'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "menu-link text-center",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(goTo)('clients','klienci')))
                    }, _hoisted_33))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_media'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "menu-link text-center",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(goTo)('media','media')))
                    }, _hoisted_36))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_statystykiDruku'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "menu-link text-center",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(goTo)('stats','statystyki')))
                    }, _hoisted_39))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_logSystemu'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: "menu-link text-center",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(goTo)('log','log')))
                    }, _hoisted_42))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_wiadomosci'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 7,
                      class: "menu-link text-center",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(goTo)('messages','wiadomości')))
                    }, [
                      _hoisted_43,
                      _hoisted_44,
                      (unreadMessages.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_archiwumZlecen'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 8,
                      class: "menu-link text-center",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(goTo)('archive','archiwum')))
                    }, _hoisted_48))
                  : _createCommentVNode("", true),
                (canISeeThis('menu_uzytkownicy'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 9,
                      class: "menu-link text-center",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(goTo)('users','użytkownicy')))
                    }, _hoisted_51))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isAuth.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})